import { useContext, useEffect, useState } from 'react';
import '../classes/styles/style.css';
import Screen from '../components/screen';
import * as WS from '../webServices/cyMyManager'
import Spinner from '../components/spinner';
import { GetGlobalContext, GlobalContextData } from '../classes/context';
import Modal from '../components/modal';
import ActionBtn from '../components/actionBtn';
import TableClienti from '../mobile-components/tableClienti';

export default function Clienti() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const [clienti, setClienti] = useState<WS.Plus.IF.Cliente[] | undefined>(undefined)
    const [modalShow, setModalShow] = useState(false)
    const [clienteSel, setClienteSel] = useState<WS.Plus.IF.Cliente | undefined>(undefined)
    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(undefined);
    const [filSedeSel, setFilSedeSel] = useState<string | undefined>(undefined)
    const [veicoli, setVeicoli] = useState<WS.Plus.IF.Veicolo[]>([])
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const passToModal = (cliente: WS.Plus.IF.Cliente) => {
        setModalShow(true);
        setClienteSel(cliente)
    }

    const onLoad = async (): Promise<void> => {
        // await updateListaAbb()

        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 0, 0);
        // let listServ = await WS.Plus.getListaArticoli(WS.UT.TOKEN, "", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
        if (listSedi.isOk) {
            setSedi(listSedi.list);
            setFilSedeSel(listSedi.list[0].Id.toString())
        }

        let listVeicoli = await WS.Plus.getListaVeicoli(WS.UT.TOKEN, "", 0, 0, 0, 0, 0, 1)

        if (listVeicoli.isOk) {
            setVeicoli(listVeicoli.list)
        } else {
            alert(listVeicoli.msgErr)
        }

    }

    const updateListaCli = async (): Promise<void> => {
        let listOrd = await WS.Plus.getListaAbbonamVend(WS.UT.TOKEN, 0, '', '', '', '', 0, 0, 0, parseInt(filSedeSel!), '', 0, 0, 0)

        let clientiNew: WS.Plus.IF.Cliente[] = [];
        listOrd.list.forEach(o => {
            if (!clientiNew.some(x => x.Id === o.IdCliente))
                clientiNew.push({ ...WS.Plus.IF.ClienteInit(), Id: o.IdCliente, RagioneSociale: o.desCliente });
        });

        clientiNew.sort((a, b) => a.Id - b.Id);
        setClienti(clientiNew);


        // if (listServ.isOk) {
        //     setServ(listServ.list);
        //     setServMultOpt(listServ.list.map(serv => ({ label: serv.Descrizioni[0].Descrizione, value: serv.Id.toString() })));
        // }
    };


    useEffect(() => {
        onLoad();
        // var isSubscribed = true;
        // WS.Plus.getListaOrdini(WS.UT.TOKEN, 3, globalContext.vars.esercente?.Id ?? 0, 0, "", "", 0, 0).then(listOrd => {
        //     if (isSubscribed) {
        //         let clientiNew: WS.Plus.IF.Cliente[] = [];
        //         listOrd.list.filter(o => o.IdSedeEserc === 1 || o.IdSedeEserc === 2).forEach(o => {
        //             if (!clientiNew.some(x => x.Id === o.IdCliente))
        //                 clientiNew.push({ ...WS.Plus.IF.ClienteInit(), Id: o.IdCliente, RagioneSociale: o.DescrCliente, EMail: o.emailCliente });
        //         });

        //         clientiNew.sort((a, b) => a.Id - b.Id);
        //         setClienti(clientiNew);
        //     }
        // });

        // return () => {
        //     isSubscribed = false;
        // }
    }, []);

    useEffect(() => {
        if (filSedeSel !== undefined)
            updateListaCli()

    }, [filSedeSel])


    return (
        <Screen>
            <div className='container'>
                <div className='row'>
                    <div className='d-flex card flex-row mb-3' >
                        <h2>Clienti</h2>
                        <div className='ms-auto'>
                            <div style={{ display: 'inline-block', marginRight: '0.5em' }}>
                                <select name="sedEseSel" className='form-select' value={filSedeSel} onChange={(s) => setFilSedeSel(s.target.value)}>
                                    {sedi ?
                                        sedi.map((sede, s) =>
                                            <option key={s} value={sede.Id}>{sede.Indirizzo}</option>
                                        )
                                        :
                                        undefined
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 card'>
                        <table className="table">
                            <thead>
                                <tr>
                                    {isMobile ?
                                        <></>
                                        :
                                        <>
                                            <th scope="col">#</th>
                                            <th scope="col">Nome</th>
                                            {/* <th scope="col">email</th> */}
                                        </>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {clienti ?
                                    clienti.map((cliente, c) =>
                                        isMobile ?
                                            <TableClienti cliente={cliente} passToModal={() => passToModal(cliente)} />
                                            :
                                            <>
                                                <tr className='pointer' key={c}>
                                                    <th scope="row" onClick={() => passToModal(cliente)}>{cliente.Id}</th>
                                                    <td onClick={() => passToModal(cliente)}>{cliente.RagioneSociale}</td>
                                                    {/* <td onClick={() => passToModal(cliente)}>{cliente.EMail}</td> */}
                                                </tr>
                                            </>

                                    )
                                    :
                                    <Spinner />
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <Modal
                isShow={modalShow}
                onClose={() => setModalShow(false)}
                title=""
                body={
                    <>
                        <h5>{clienteSel?.RagioneSociale}</h5>
                        <p>{clienteSel?.EMail}</p>
                        {veicoli.filter(x => x.IdCliente === clienteSel?.Id).map((x, idx) =>
                            <div className='row' key={idx}>
                                <div className='col-12 col-md-6 mb-3'>
                                    <label htmlFor="prezzoAbb">Marca Veicolo</label>
                                    <input className="form-control" type="number" placeholder={x.desVeiCostr} disabled={true} />
                                </div>
                                <div className='col-12 col-md-6 mb-3'>
                                    <label htmlFor="prezzoAbb">Modello Veicolo</label>
                                    <input className="form-control" type="number" placeholder={x.desVeiModello} disabled={true} />
                                </div>
                                <div className='col-12 col-md-6 mb-3'>
                                    <label htmlFor="prezzoAbb">Targa Veicolo</label>
                                    <input className="form-control" type="number" placeholder={x.Targa} disabled={true} />
                                </div>
                                <div className='col-12 col-md-6 mb-3'>
                                    <label htmlFor="prezzoAbb">Segemento Veicolo</label>
                                    <input className="form-control" type="number" placeholder={x.desVeiSegmento} disabled={true} />
                                </div>
                                <div className='col-12 col-md-6 mb-3'>
                                    <div className='valid-label' style={{ background: x.Validato === 1 ? undefined : 'var(--bs-danger)' }}>{x.Validato === 1 ? "Valido" : "Non Valido"}</div>
                                </div>
                            </div>
                        )}
                    </>
                }
            />
        </Screen>
    );
}

